import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import LegalPage, { Section, H3, P } from "./components/LegalPage";
import { brand as ds } from "./designSystem";
import Home from "./Home";
import Impressum from "./Impressum";
import Datenschutz from "./Datenschutz";
import AGB from "./AGB";
import TextHumanizerPage from "./TextHumanizerPage";
import GamesHub from "./games/GamesHub";
import GamePlayPage from "./games/GamePlayPage";
import Kuendigung from "./Kuendigung";
import Widerruf from "./Widerruf";
import AdminStats from "./AdminStats";
import CookieConsent from "./components/CookieConsent";
import React, { useEffect, useRef } from "react";
import { db } from "./firebase"; // Dein initialisiertes DB-Objekt
import { doc, updateDoc, increment } from "firebase/firestore";

const App = () => {
  const hasRun = useRef(false);

  useEffect(() => {
    // Verhindere den doppelten Aufruf im React Strict Mode
    if (hasRun.current) {
      return;
    }
    hasRun.current = true;

    // --- Dein verbesserter Firestore-Code beginnt hier ---

    // 1. Hole das aktuelle Datum im Format YYYY-MM-DD
    const today = new Date();
    // Nutze ISO-Format und nimm nur den Datumsteil (z.B. "2025-12-15")
    const dateKey = today.toISOString().substring(0, 10);

    // Referenz auf das Hauptmetrik-Dokument
    const counterRef = doc(db, "metrics", "site_stats");

    // Aktualisiere das Dokument
    updateDoc(counterRef, {
      // Zähle die Gesamtaufrufe wie bisher hoch
      total_page_views: increment(1),

      // Erstelle oder inkrementiere das Feld für das heutige Datum
      // Wir verwenden hier das "Punktnotation"-Update, um ein Feld dynamisch zu setzen.
      [`daily_views.${dateKey}`]: increment(1),
    })
      .then(() => {
        console.log(
          `Seitenaufruf für gesamt und ${dateKey} erfolgreich gezählt.`
        );
      })
      .catch((error) => {
        console.error("Fehler beim Zählen des Seitenaufrufs: ", error);
      });
    // --- Dein verbesserter Firestore-Code endet hier ---
  }, []);
  // Auf der Subdomain games.schriftbot.com zeigt die Startseite direkt die
  // Spiele. (Zusätzlich muss die Domain in Firebase Hosting + DNS verbunden
  // und in Firebase Auth als autorisierte Domain eingetragen sein.)
  const isGamesHost = window.location.hostname.startsWith("games.");

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={isGamesHost ? <GamesHub /> : <Home />} />
        <Route path="/text-generator" element={<TextHumanizerPage />} />

        <Route path="/games" element={<GamesHub />} />
        <Route path="/games/:gameId" element={<GamePlayPage />} />

        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />

        <Route path="/success" element={<Success />} />
        <Route path="/agb" element={<AGB />} />
        <Route path="/kuendigen" element={<Kuendigung />} />
        <Route path="/widerruf" element={<Widerruf />} />
        <Route path="/admin" element={<AdminStats />} />        <Route
          path="*"
          element={
            <div
              style={{
                minHeight: "100vh",
                background: ds.color.canvas,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 20,
                padding: 40,
                textAlign: "center",
              }}
            >
              <h1
                style={{
                  fontFamily: ds.font.display,
                  fontWeight: 400,
                  fontSize: ds.text.hero,
                  lineHeight: ds.leading.tight,
                  letterSpacing: ds.tracking.tight,
                  color: ds.color.ink,
                  margin: 0,
                }}
              >
                Seite nicht gefunden
              </h1>
              <p
                style={{
                  fontFamily: ds.font.body,
                  fontSize: 18,
                  lineHeight: 1.65,
                  color: ds.color.muted,
                  margin: 0,
                  maxWidth: 420,
                }}
              >
                Diese Adresse gibt es nicht — vielleicht hat sich ein Tippfehler
                eingeschlichen.
              </p>
              <Link to="/" className="sb-btn sb-btn-primary">
                Zurück zur Startseite
              </Link>
            </div>
          }
        />
      </Routes>
      <CookieConsent />
    </BrowserRouter>
  );
};

export default App;

const Success = () => (
  <LegalPage
    title="Zahlung erfolgreich"
    intro="Danke — dein Zugang ist freigeschaltet."
  >
    <Section>
      <P>
        Wir haben deine Zahlung erhalten und dein Konto sofort freigeschaltet.
        Eine Bestätigung deiner Bestellung — mit den Vertragsdaten, den AGB und
        der Widerrufsbelehrung — schicken wir dir zusätzlich per E-Mail zu.
      </P>
      <P muted>
        Dein Abo verlängert sich monatlich, bis du kündigst. Kündigen kannst du
        jederzeit zum Ende des laufenden Abrechnungsmonats, ohne Anmeldung und
        ohne Angabe von Gründen.
      </P>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 12,
          marginTop: 24,
        }}
      >
        <Link to="/" className="sb-btn sb-btn-primary">
          Weiter zum Editor
        </Link>
        <Link to="/kuendigen" className="sb-btn sb-btn-secondary">
          Abo kündigen
        </Link>
      </div>
    </Section>

    <Section>
      <H3>Fragen zur Bestellung?</H3>
      <P muted style={{ margin: 0 }}>
        Schreib uns an{" "}
        <a href="mailto:schriftbot@gmail.com" className="sb-link">
          schriftbot@gmail.com
        </a>
        . Wir antworten in der Regel innerhalb von drei Werktagen.
      </P>
    </Section>
  </LegalPage>
);
